import { defineMessages } from 'react-intl';

export default defineMessages({
	btnRemoveDeviceId: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.removeDeviceId',
		defaultMessage: 'Remove Device ID',
	},
	btnSuspendTicket: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.suspendTicket',
		defaultMessage: 'Suspend Ticket',
	},
	btnReactivateTicket: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.reactivateTicket',
		defaultMessage: 'Re-activate sTicket',
	},
	btnCancel: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.cancel',
		defaultMessage: 'Cancel',
	},
	btnOk: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.ok',
		defaultMessage: 'OK',
	},
	lblSuccess: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.success',
		defaultMessage: 'Success!',
	},
	dlgRemoveDeviceIdDescription: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.removeDeviceIdDialog.description',
		defaultMessage:
			'Are you sure you want to remove this device ID? This will stop the sTicket working on the users current device.',
	},
	dlgSuspendTicketDescription: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.suspendTicketDialog.description',
		defaultMessage:
			'Are you sure you want to suspend this sTicket? This will cancel any active coupons on the ticket and prohibit the user from generating any new ones?',
	},
	dlgReactivateTicketTitle: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.reactivateTicketDialog.title',
		defaultMessage: 'Reactivate sTicket',
	},
	dlgReactivateTicketDescription: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.reactivateTicketDialog.description',
		defaultMessage: 'Are you sure you want to reactivate this sTicket?',
	},
	dlgSTicketError: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.sTicketDialog.error',
		defaultMessage: 'An error occurred. Please try again.',
	},
	calloutSuspended: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.suspended',
		defaultMessage: 'This sTicket has been suspended.',
	},
	calloutSuspendedLabel: {
		id: 'app.shopping.manageBooking.fulfillmentInformation.suspended.label',
		defaultMessage: 'SUSPENDED',
	},
});
